import React, { ReactNode } from 'react';
import './icon-button.scss';

interface IconButtonProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'children' | 'type'> {
  icon: ReactNode;
  /** Accessible name and tooltip. Required: the icon alone says nothing to a reader. */
  label: string;
  tone?: 'default' | 'danger' | 'accent';
  size?: 'sm' | 'md';
  /** Pressed look, for a control that stays on (an expanded disclosure). */
  active?: boolean;
}

/**
 * A square, borderless icon button. Always `type="button"` so one inside a
 * form never submits it.
 */
const IconButton: React.FC<IconButtonProps> = ({
  icon,
  label,
  tone = 'default',
  size = 'md',
  active = false,
  className = '',
  ...rest
}) => (
  <button
    type="button"
    className={`icon-btn icon-btn--${size} icon-btn--${tone} ${active ? 'is-active' : ''} ${className}`.trim()}
    aria-label={label}
    aria-pressed={active || undefined}
    title={label}
    {...rest}
  >
    {icon}
  </button>
);

export default IconButton;
